require('./bootstrap');

document.addEventListener('DOMContentLoaded', () => {
    // bootstrap tooltip
    $('[data-toggle="tooltip"]').tooltip();

    $('.alert').not('.alert-important').delay(3000).fadeOut(350);

    $('#flash-overlay-modal').modal();

    $('.toast').toggle({
        autohide: false,
        delay:3000
    });

    $('.toast').toast('show');

    $('.table-link tbody tr > td').hover(function () {
        $(this).css('cursor', 'pointer');
    });

    $('#mobile-button').click(function () {
        let menu = $('aside');
        let posX = menu.css('right');
        if (posX == '-200px') {
            menu.css('right', 0);
        } else {
            menu.css('right', '-200px');
        }
    });

    $(function () {
        // 최상단 회사명은 HOME과 링크가 같으므로 활성 표시에서 제외한다.
        $('aside li:not(.aside-brand) > a[href="' + currentUrl + '"]').addClass('active');
        $('aside li:not(.aside-brand) > a[href="' + currentFullUrl + '"]').addClass('active');

        let activeMenu = $('aside .nav-link.active');
        if (activeMenu.parents('ul').hasClass('collapse')) {
            activeMenu.parents('.collapse').addClass('show');
        }
    });
})

// 숫자 포맷팅 함수 (소숫점 지원)
window.addComma = (x) => {
    if (!x && x !== 0) return '0';
    const str = String(x).replace(/,/g, '');
    const parts = str.split('.');
    // 정수 부분에만 콤마 추가
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join('.');
};

window.removeComma = (x) => {
    if (!x && x !== 0) {
        return '0';
    }
    // 콤마 제거, 소숫점은 보존
    return String(x).replace(/,/g, '');
};

// 숫자만 입력
window.onlyNumbers = function (event) {
    event.preventDefault();
    let key = String(event.which);
    let exp = /^(8|9|37|39|48|49|50|51|52|53|54|55|56|57)+$/gi;

    if (null !== key.match(exp)) {
        event.returnValue = true;
    } else {
        event.returnValue = false;
    }
};

// 알림 창
window.alertInfo = (status, msg, timeout = 3000) => {
    let tg = document.querySelector('#info-alarm');
    let status_title = status === 'danger' ? '오류' : '안내';
    let tpl = `<div class="alert alert-${status}">${msg}</div>`;
    tg.innerHTML = tpl;

    tg.style.display = '';

    setTimeout(() => {
        tg.style.display = 'none';
        tg.innerHTML = '';
    }, timeout)
};


// 폼 전송 전 컨펌
window.confirmDelete = () => {
    return confirm('정말 삭제할까요?');
};

// 메모 완료 처리, 삭제
// 메모 완료처리
window.checkDone = function (obj) {
    let id = obj.value;
    let status = obj.checked;

    axios.put("/api/memo/" + id, {done: status})
        .catch(function (err) {
            err.response
                ? alertInfo('danger', err.response.data.message)
                : alertInfo('danger', err.message);
        })
};

// 메모 삭제
window.delMemo = function (id, obj) {
    if (!confirm('삭제할까요?')) return false;
    axios.delete('/api/memo/' + id)
        .then(function (r) {
            obj.closest('tr').remove();
        })
        .catch(function (err) {
            alert(err.response ? err.response.data.message : err.message);
        });
};

// 알림창 (toast)
window.showAlarm = (title, message, hide_time = 0, status = 'info') => {
    const tpl = document.querySelector('#toast-tpl').content.cloneNode(true);

    let icon = 'alert-circle';
    let bgColor = 'bg-primary';
    switch ( status ) {
        case 'error' : icon = 'alert-triangle'; bgColor='bg-danger'; break;
        case 'success' : icon = 'smile'; bgColor='bg-success'; break;
        default : icon = 'alert-circle'; bgColor='bg-primary';
    }

    tpl.querySelector('i[data-feather]').dataset.feather = icon;
    tpl.querySelector('.toast-header').classList.add(bgColor);
    tpl.querySelector('.toast-header strong').textContent = title;
    tpl.querySelector('.toast-body').innerText = message;

    if ( hide_time > 0 ) {
        tpl.querySelector('.toast').dataset.autohide = 'true';
        tpl.querySelector('.toast').dataset.delay = hide_time * 1000;
    }

    document.querySelector('#alert').appendChild(tpl);
    const t = document.querySelector('#alert .toast:last-child');
    feather.replace();
    $(t).toast('show');
};

window.setCookie = (name, value, exp) => {
    let date = new Date();
    date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + escape(value) + ';expires=' + date.toUTCString() + ';path=/';
}

window.getCookie = (name) => {
    let value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return value ? unescape(value[2]) : null;
}

window.resetCookie = (cName) => {
    let expireDate = new Date();
    expireDate.setDate(expireDate.getDate() - 1);
    document.cookie = cName + "= " + "; expires=" + expireDate.toGMTString() + "; path=/";
}

window.nl2br = (string) => {
    if (!string) {
        return '';
    }

    return string.replace(/\n/g, '<br>');
}

window.checkAll = (obj) => {
    const items = obj.closest('table').querySelectorAll('input[type="checkbox"]');
    items.forEach(item=>{
        item.checked = obj.checked;
    })
}
